import { Order } from "@amzn/ito-client";

const REGEX_MIDWAY_SERVICE_ACCOUNT = /svc-mw-(?<account>[a-zA-Z\d]+)-(?<role>[a-zA-Z\d]+)-?l?(?<level>\d)?/;

export function hasAmazonianLabel(order: Order, amazonianLabelString: string): boolean {
    return Boolean(order.orderLabels?.some(labelStamp => labelStamp.label === amazonianLabelString));
}

export enum OrderSource {
    ITSE = "ITSE",
    HAM = "ham",
    AMZNHAM = "amznham",
}

export function whereIsOrderFrom(order: Order) {
    if (order.orderLabels?.some(label => label.label === "ITSE")) return OrderSource.ITSE;
    return order.orderLabels?.some(label => label.via === "amznham") ? OrderSource.AMZNHAM : OrderSource.HAM;
}

export function replaceTaxonomyWithOrderReference(newPath: string, id: string) {
    const path = newPath.slice(0, newPath.lastIndexOf("/")) + "/" + id;
    window.history.replaceState(null, "", path);
}

export const isServiceAccount = (username: string) => {
    if (REGEX_MIDWAY_SERVICE_ACCOUNT.exec(username)) {
        return true;
    }
    return false;
}